import { MappedBillingDocument } from '../accounts/types';
import { CbCreditNoteData, ZatcaMessage } from '../shared/types';

export interface BaseInvoiceDTO {
  email: string;
  customerName: string;
  chargebeeInvoiceCreationDate: Date;
  subscriptionStartDate: Date;
  subscriptionEndDate: Date;
  zatcaApprovedInvoiceId?: string;
  zatcaInvoiceCreationDate: Date;
  paymentStatus: string;
  creditNoteVisibility?: boolean;
  zatcaError?: ZatcaMessage[];
  zatcaQrCode?: string;
  createdAt?: Date;
  webhookTimestamp?: string;
  sequencedId?: string;
  oldSequencedId?: string;
  total?: number;
  adjustment_credit_notes?: CbCreditNoteData[];
  issued_credit_notes?: CbCreditNoteData[];
}

export interface ChargebeeZatcaInvoiceDTO extends BaseInvoiceDTO {
  zatcaStatus: string;
  zatcaError: ZatcaMessage[];
  zatcaWarning?: ZatcaMessage[];
  errorBlob: object;
  invoiceType: string;
  chargebeeInvoiceId: string;
}

export interface ChargebeeZatcaReturnInvoiceDTO extends BaseInvoiceDTO {
  zatcaStatus: string;
  zatcaWarning: ZatcaMessage[];
  zatcaError: ZatcaMessage[];
  errorBlob: object;
  creditNoteStatus: string;
  chargebeeCreditNoteId: string;
  sequencedReferenceId?: string;
  sequencedOldReferenceId?: string;
  referenceInvoiceZatcaStatus: string;
}

export interface ChargebeeZatcaInvoicesResponseDTO {
  total: number;
  data: ChargebeeZatcaInvoiceDTO[];
  hardwareType?: string;
}

export interface ChargebeeZatcaReturnInvoicesResponseDTO {
  total: number;
  data: ChargebeeZatcaReturnInvoiceDTO[];
}
export type FilterType = { start: string; end: string } | string[];

export interface LinkedPaymentWithPaymentMethod {
  bankName?: string;
  paymentMethod: string;
  txn_id: string;
  applied_amount: number;
  applied_at: number;
  txn_status?: string;
  txn_date?: number;
  txn_amount?: number;
}
export interface MappedBillingDocumentWithPaymentReceiptData
  extends MappedBillingDocument {
  monshaatOrderNumber?: string;
  lastUpdated?: number;
  txnData?: LinkedPaymentWithPaymentMethod[];
  totalCollectedAmount?: number;
  excessBalance?: number;
  printingSubtotal?: number;
  totalDiscount?: number;
  totalTaxableAmount?: number;
  zatcaQrCode?: string;
  createdAt?: Date;
  webhookTimestamp?: string;
  sequencedId?: string;
  oldSequencedId?: string;
  sequencedReferenceId?: string;
  sequencedOldReferenceId?: string;
  monshaatDiscountVatIncl?: number;
  rewaaDiscountVatIncl?: number;
  monshaatCompanyName?: string;
  notes?: string;
}

export type ZATCAWarningsAndErrors = {
  errors: ZatcaMessage[];
  warnings: ZatcaMessage[];
  nucleusEnigma: Error;
};

export enum PaymentStatus {
  Paid = 'Paid',
  PartiallyPaid = 'Partially Paid',
  NotPaid = 'Not Paid',
}
